const Logo = () => (
  <svg width="27" height="35" viewBox="0 0 27 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.85 28.36C8.75 28.36 6.14 27.52 4.02 25.84C1.9 24.16 0.84 21.75 0.84 18.61C0.84 16.77 1.19 15.13 1.89 13.69C2.59 12.25 3.51 11.12 4.65 10.3C6.95 8.62 9.53 7.78 12.39 7.78C14.05 7.78 15.78 8.08 17.58 8.68L17.28 10.72C16.34 10.32 15.61 10.02 15.09 9.82C13.59 9.28 12.08 9.01 10.56 9.01C8.46 9.49 6.84 10.53 5.7 12.13C4.58 13.73 4.02 15.73 4.02 18.13C4.02 21.07 4.79 23.34 6.33 24.94C7.87 26.52 9.9 27.31 12.42 27.31C14.94 27.31 16.82 26.77 18.06 25.69V27.34C16.34 28.02 14.27 28.36 11.85 28.36Z" fill="#DFE4D4" />
    <path d="M11.61 18.16V28H8.7V8.14H11.61V17.02H20.7V8.14H23.61V28H20.7V18.16H11.61Z" fill="#C0AC9D" />
  </svg>
)

export default Logo
